export const REQUESTS_ROUTE_PATH = '/requests';
